// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/preferences/planning_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_financial_budget } from "../financial/budget_pb";
import { file_proto_model_core_common } from "../core/common_pb";

/**
 * Describes the file proto/model/preferences/planning_preferences.proto.
 */
export const file_proto_model_preferences_planning_preferences = /*@__PURE__*/
  fileDesc("CjJwcm90by9tb2RlbC9wcmVmZXJlbmNlcy9wbGFubmluZ19wcmVmZXJlbmNlcy5wcm90bxIGY2FybWVuIr4BChNQbGFubmluZ1ByZWZlcmVuY2VzEhAKCGN1cnJlbmN5GAEgASgJEhYKDmRlcGFydHVyZV9jaXR5GAIgASgJEhkKEWRlcGFydHVyZV9haXJwb3J0GAMgASgJEjEKEG1lYXN1cmVtZW50X3VuaXQYBCABKA4yFy5jYXJtZW4uTWVhc3VyZW1lbnRVbml0Ei8KD2J1ZGdldF90ZW1wbGF0ZRgFIAEoCzIWLmNhcm1lbi5CdWRnZXRUZW1wbGF0ZUIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z", [file_proto_model_financial_budget, file_proto_model_core_common]);

/**
 * Describes the message carmen.PlanningPreferences.
 * Use `create(PlanningPreferencesSchema)` to create a new message.
 */
export const PlanningPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_preferences_planning_preferences, 0);

